import { ResultOf } from "gql.tada";
import { GetProductPageById } from "@queries/archetypes/GetProductPageById";
import { Hero } from "@components/entries/Hero";
import { SolutionsSection } from "@components/entries/SolutionsSection";
import { RoutingSection } from "@components/entries/RoutingSection";
import { ColumnLegalSection } from "@components/entries/ColumnLegalSection";

type ProductPageData = NonNullable<
  ResultOf<typeof GetProductPageById>["productPage"]
>;

export const ProductPageRenderer = ({ data }: { data: ProductPageData }) => {
  return (
    <>
      {data.hero && (
        <Hero entry={{ hero: data.hero } as any} />
      )}
      {data.solutions && (
        <SolutionsSection
          entry={{ solutionsSection: data.solutions } as any}
        />
      )}
      {data.legal?.__typename === "TwoColumnRichTextSection" && (
        <ColumnLegalSection
          entry={{ twoColumnRichTextSection: data.legal } as any}
        />
      )}
      {data.routing && (
        <RoutingSection
          entry={{ routingSection: data.routing } as any}
        />
      )}
    </>
  );
};
